<template>
    <div class='step_cont'>
        <div class='step_name active one'>
            填写
            <div class='active_line'></div>
        </div> 
        <div class='line'></div>
        <div class='step_name'>
            支付
            <!-- <div class='active_line'></div> -->
        </div>
        <div class='line'></div>
        <div class='step_name three'>
            完成
            <!-- <div class='active_line'></div> -->
        </div>
    </div>
</template>
<script>

export default {
    componentname: "step",
    props:{
        model:{
            type:Object,
            default:function(){
                return {}
            }
        },
    },
    setup(){
        

        return {
   
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .step_cont{
        height: 60px;
        background: #F8F8F8;
        border: 0.5px solid #CDCCCD;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        .one{
            position: relative;
            left:-1px;
        }
        .step_name{
            
            width: 90px;
            text-align: center;
            line-height: 60px;
            position: relative;
            .active_line{
                position: absolute;
                height: 7px;
                width: 100%;
                background: #409EFF;
                top:0;
            }
        }
        .active{
            background: #fff!important;
            color:#3999FB!important;
        }
        .line{
            height: 0.5px;
            background: #DEDFE3;
            width: 225px;

        }
    }
</style>

